import React, { useEffect, useRef, useState ,forwardRef, useImperativeHandle} from 'react';

import '../../slider.css';
import "./imageSlider.css";

const ImageSlider = ({ images, onLoad }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const sliderRef = useRef();
  const [loadedCount, setLoadedCount] = useState(0);
  const [touchStartPos, setTouchStartPos] = useState(null);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [isVerticalScrolling, setIsVerticalScrolling] = useState(false);

  // 더 직접적인 접근: wheel 이벤트로 세로 스크롤 감지
  const handleWheel = (e) => {
    
    // 세로 스크롤 (deltaY)이 가로 스크롤(deltaX)보다 큰 경우
    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
      e.preventDefault();
      e.stopPropagation();
      
             // 부모 컨테이너 찾기 - PinContent의 메인 컨테이너
       let parentScrollContainer = sliderRef.current?.parentElement;
       while (parentScrollContainer && !parentScrollContainer.style.overflowY) {
         parentScrollContainer = parentScrollContainer.parentElement;
       }
       
       // PinContent의 containerStyle이 적용된 div를 찾기
       if (!parentScrollContainer) {
         parentScrollContainer = sliderRef.current?.closest('div[style*="overflow-y: auto"]');
       }
       
       if (parentScrollContainer) {
         parentScrollContainer.scrollBy(0, e.deltaY);
       }
    } 
  };

  // 스크롤 이벤트 핸들러
  const handleScroll = () => {
    const index = Math.floor(sliderRef.current.scrollLeft / sliderRef.current.offsetWidth);
    setCurrentIndex(index);
  };

  // 이전 이미지로 이동
  const goToPrevious = () => {
    const newIndex = currentIndex > 0 ? currentIndex - 1 : images.length - 1;
    handleIndicatorClick(newIndex);
  };

  // 다음 이미지로 이동
  const goToNext = () => {
    const newIndex = currentIndex < images.length - 1 ? currentIndex + 1 : 0;
    handleIndicatorClick(newIndex);
  };

  useEffect(() => {
    // 모든 이미지가 로드되었을 때만 슬라이더 위치 초기화
    if (loadedCount === images.length) {
      const slider = sliderRef.current;
      slider.scrollLeft = 0;
      setCurrentIndex(0);
      if(onLoad) onLoad();
    }
  }, [loadedCount, images.length]);

  useEffect(() => {
    const slider = sliderRef.current;
    
    if (slider) {
      slider.addEventListener('scroll', handleScroll, { passive: true });
      slider.addEventListener('wheel', handleWheel, { passive: false });
    }
    
    // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
    return () => {
      if (slider) {
        slider.removeEventListener('scroll', handleScroll);
        slider.removeEventListener('wheel', handleWheel);
      }
    };
  }, []);

   // 인디케이터 클릭 핸들러
   const handleIndicatorClick = (index) => {
    const slider = sliderRef.current;
    const newScrollLeft = index * slider.offsetWidth;
    slider.scrollTo({ left: newScrollLeft, behavior: 'smooth' });
    setCurrentIndex(index);
  };

  const handleImageLoad = () => {
    setLoadedCount((prevCount) => prevCount + 1);
  };

  if (images === null || images === undefined || images.size === 0)
    return <></>;

  const arrowButtonStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '60px',
    height: '60px',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    border: 'none',
    borderRadius: '50%',
    color: 'white',
    fontSize: '54px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 20,
    transition: 'all 0.3s ease',
  };

  const leftArrowStyle = {
    ...arrowButtonStyle,
    left: '10px',
  };

  const rightArrowStyle = {
    ...arrowButtonStyle,
    right: '10px',
  };


  
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <div
        ref={sliderRef}
        style={{ 
          overflowX: 'auto', 
          overflowY: 'visible',
          scrollSnapType: 'x mandatory', 
          display: 'flex', 
          width: '100%',
          touchAction: 'pan-y pinch-zoom',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          {images.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`${index}`}
              onLoad={handleImageLoad}
              style={{ 
                width: '100%', 
                flex: '0 0 auto', 
                scrollSnapAlign: 'start',
                userSelect: 'none',
                WebkitUserSelect: 'none',
                pointerEvents: 'none',
              }}
            />
          ))}
        </div>
      </div>

      {/* 왼쪽 화살표 버튼 */}
      {images.length > 1 && (
        <button
          style={{...leftArrowStyle, paddingBottom: "5px",paddingRight: "8px" }}
          onClick={goToPrevious}
        >
          {/iPhone|iPad|iPod/i.test(navigator.userAgent) ? (
            <span style={{color: 'transparent'}}>&#8249;<span style={{color: 'white'}}>&#8249;</span>&#8249;</span>            
          ) : (
            <>&#8249;</>
          )}

        </button>
      )}


      {/* 오른쪽 화살표 버튼 */}
      {images.length > 1 && (
        <button
          style={{...rightArrowStyle, paddingBottom: "5px", paddingLeft:"8px" }}
          onClick={goToNext}
        >
          {/iPhone|iPad|iPod/i.test(navigator.userAgent) ? (
            <span style={{color: 'transparent'}}>&#8250;<span style={{color: 'white'}}>&#8250;</span>&#8250;</span>
          ) : (
            <>&#8250;</>
          )}
          
        </button>
      )}

      {/* 인디케이터 */}
      <div id="indicator" style={{ textAlign: 'center', position:"absolute", bottom:0, left:0, right:0, zIndex:10 }}>
        {images.map((_, index) => (
          <div
            key={index}
            onClick={() => handleIndicatorClick(index)}
            style={{
              display: 'inline-block',
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              backgroundColor: currentIndex === index ? 'white' : 'grey',
              margin: '5px',
              cursor: 'pointer',
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageSlider;